import type { JSX } from 'react'
import type { IButtonProps } from '../Button'

import { IconNames } from 'atoms/Icon'
import { COLOR, FIXED_INDENTS } from 'vars/index'
import { Button } from '../Button'
import {
  ButtonBordersWidth,
  ButtonCorners,
  ButtonFluid,
  ButtonIconSizes,
} from '../Button.h'

export interface ITrueIdLoginButtonProps extends IButtonProps {}

export const TrueIdLoginButton = ({
  icon = IconNames.trueIdLogo,
  iconSize = ButtonIconSizes.big,
  iconHeight = ButtonIconSizes.xMedium,
  corners = ButtonCorners.CORNERS_0,
  paddings = [FIXED_INDENTS.INDENT_30, FIXED_INDENTS.INDENT_60],
  backgroundColorDefault = COLOR.BASE_MAIN_DEFAULT,
  backgroundColorHovered = COLOR.SURFACE_LIGHT_2,
  backgroundColorPressed = COLOR.BASE_MAIN_PRESSED,
  backgroundColorDisabled = COLOR.DISABLED,
  borderWidth = ButtonBordersWidth.BORDER_0,
  fluid = ButtonFluid.Horizontal,
  onClick,
  ...rest
}: ITrueIdLoginButtonProps): JSX.Element | null => (
  <Button
    icon={icon}
    iconSize={iconSize}
    iconHeight={iconHeight}
    corners={corners}
    paddings={paddings}
    backgroundColorDefault={backgroundColorDefault}
    backgroundColorHovered={backgroundColorHovered}
    backgroundColorPressed={backgroundColorPressed}
    backgroundColorDisabled={backgroundColorDisabled}
    borderWidth={borderWidth}
    fluid={fluid}
    onClick={onClick}
    {...rest}
  />
)
